import { render, staticRenderFns } from "./MenuItemsEditorCategoryEntrees.vue?vue&type=template&id=321a71a4&scoped=true&"
import script from "./MenuItemsEditorCategoryEntrees.vue?vue&type=script&lang=js&"
export * from "./MenuItemsEditorCategoryEntrees.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemsEditorCategoryEntrees.vue?vue&type=style&index=0&id=321a71a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321a71a4",
  null
  
)

export default component.exports